import Swal from "sweetalert2";

const ACTION_COPY = {
  commission: (name) => `${name} moved to commissionable`,
};

const CONFIRM_COPY = {
  commission: {
    title: "Move to commissionable?",
    confirmText: "Yes, move to commissionable",
  },
  remove_commissionable: {
    title: "Remove from commissionable?",
    confirmText: "Yes, remove",
  },
};

export async function confirmClientAction({ clientName, type }) {
  const name = clientName?.trim() || "this client";
  const copy = CONFIRM_COPY[type] || CONFIRM_COPY.commission;

  const result = await Swal.fire({
    title: copy.title,
    text: `Move ${name} from General into Commissionable Students? They stay there permanently until you remove them from commissionable.`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: copy.confirmText,
    cancelButtonText: "Cancel",
    confirmButtonColor: "#007BFF",
    cancelButtonColor: "#6B7280",
    reverseButtons: true,
    focusCancel: true,
  });

  return result.isConfirmed;
}

export async function confirmRemoveFromCommissionable({ clientName }) {
  const name = clientName?.trim() || "this client";
  const copy = CONFIRM_COPY.remove_commissionable;

  const result = await Swal.fire({
    title: copy.title,
    text: `Remove ${name} from Commissionable Students? Inquiry batches already created are not deleted.`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: copy.confirmText,
    cancelButtonText: "Cancel",
    confirmButtonColor: "#DC2626",
    cancelButtonColor: "#6B7280",
    reverseButtons: true,
    focusCancel: true,
  });

  return result.isConfirmed;
}

/** @deprecated Inquiry queue removed — kept for any leftover imports */
export async function confirmRemoveFromQueue({ clientName }) {
  return confirmRemoveFromCommissionable({ clientName });
}

export function showClientAddedToast({ clientName, type }) {
  const name = clientName?.trim() || "Client";
  const text = ACTION_COPY[type]?.(name) || `${name} updated`;

  Swal.fire({
    icon: "success",
    title: "Success",
    text,
    timer: 1800,
    showConfirmButton: false,
  });
}

export function showClientRemovedFromCommissionableToast({ clientName }) {
  const name = clientName?.trim() || "Client";

  Swal.fire({
    icon: "success",
    title: "Success",
    text: `${name} removed from commissionable`,
    timer: 1800,
    showConfirmButton: false,
  });
}

/** @deprecated Inquiry queue removed */
export function showClientRemovedFromQueueToast({ clientName }) {
  showClientRemovedFromCommissionableToast({ clientName });
}

export function showClientAlreadyAddedToast({ clientName }) {
  const name = clientName?.trim() || "Client";

  Swal.fire({
    icon: "info",
    title: "Already added",
    text: `${name} is already in commissionable`,
    timer: 1600,
    showConfirmButton: false,
  });
}

export function showClientActionErrorToast(message) {
  Swal.fire({
    icon: "error",
    title: "Action failed",
    text: message || "Something went wrong. Please try again.",
    confirmButtonColor: "#007BFF",
  });
}
